var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"margin-t-2",class:{ 'margin-x-3': _vm.stacked, 'margin-x-4': !_vm.stacked }},_vm._l((_vm.soldOutInfo),function(info,infoIndex){return _c('span',{key:`${info.messageText}-${infoIndex}`},[_c('SoldOutDetail',{attrs:{"message-text":info.messageText,"tooltip-text":info.tooltipText}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }